/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Ganturin Vladimir <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {NbCardModule, NbFormFieldModule, NbInputModule, NbListModule, NbWindowRef} from '@nebular/theme';
import {TuiIcon} from '@taiga-ui/core';
import {FormsModule} from '@angular/forms';
import {ApiResponse, BaseComponent, CustomerGroup, StoreService} from 'compob2b-libs';
import {catchError, map, take, takeUntil, tap} from 'rxjs/operators';

@Component({
  templateUrl: './modal-location.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NbCardModule, NbFormFieldModule, NbInputModule, NbListModule, FormsModule, TuiIcon]
})
export class ModalLocationComponent extends BaseComponent implements OnInit {
  groups: CustomerGroup[] = [];
  filtered: CustomerGroup[] = [];
  keyword = '';
  selectedGroup: CustomerGroup;

  constructor(
    private readonly window: NbWindowRef,
    private readonly storeService: StoreService) {
    super();
  }

  ngOnInit(): void {
    this.compoApiService.get<CustomerGroup[]>('/customer-group').pipe(
      map(response => response.data),
      takeUntil(this.unsubscribe)
    ).subscribe(groups => {
      this.groups = groups || [];
      this.applyFilter();
      this.cdr.detectChanges();
    });
    this.selectedGroup = this.storeService.getCustomerGroupLocal();
  }

  applyFilter(): void {
    const k = this.keyword.trim().toLowerCase();
    this.filtered = k
      ? this.groups.filter(g => (g.header || '').toLowerCase().includes(k))
      : this.groups;
  }

  select(group: CustomerGroup): void {
    this.getCustomerGroup(group).pipe(
      take(1),
      catchError(err => this.handleError(err)),
      tap(response => this.handleResponse(response))
    ).subscribe();
  }

  private getCustomerGroup(group: CustomerGroup) {
    this.loading = true;
    const uri = '/customer-group/' + group.id;
    return this.compoApiService.get<CustomerGroup>(uri);
  }

  private handleResponse(response: ApiResponse<CustomerGroup>) {
    setTimeout(() => {
      this.storeService.setCustomerGroup(response.data);
      this.selectedGroup = response.data;
      this.loading = false;
      this.close();
    }, 300);
  }

  close() {
    this.window.close();
  }
}
